export default [
  {
    name: 'default_footer',
    path: 'modules/pages/default/footers/FooterDefault'
  },
  {
    name: 'default_columns_footer',
    path: 'modules/pages/default/footers/FooterColumnsDefault'
  }
]
